import { Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/data-grid";
import React, { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callOperation } from "async-ops";
import MdaeDateBox from "../../common_components/common_widgets/date-box";
import MdaeSelectBox from "../../common_components/common_widgets/select-box/component";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import {
  AUDIT_PERIOD,
  REFERENCE_ID,
  NOTIFICATION_DATE,
  COMPLETED_SATUS,
} from "./constants";
import { auditModes } from "./constants";
import {
  SET_AUDIT_PROPERTIES_DATA,
  SET_IS_COMPONENT_LOADED_FLAG,
  getAuditGroupsForClaim,
  onAuditGroupValueChanged,
  onProcessTemplateValueChanged,
} from "./reducers/audit-properties-reducer";
import {
  TOGGLE_CONFIRMATION_POPUP,
} from "../../common_components/mdae-common-reducer";
import { CustomRule, AsyncRule } from "devextreme-react/data-grid";
import { GET_REFERENCE_ID_EXIST } from "./services/get-reference-id-exist";
import NotificationDateWarningPopup, {
} from "./notification-date-warning-popup";
import { cloneDeep, isEqual } from "lodash";
import StatusChangeWarningPopup, {
  toggleStatusChangeeWarningPopup,
} from "./ea_audit_status_warning_popup";
import {
  SET_EXTERNAL_AUDIT_SELECTED_INDEX,
  SET_USER_TASK_GRID_FILTER,
} from "./reducers/external-audit-reducer";
import AuditGroupProcessWarningPopup, {
  toggleAuditGroupProcessWarningPopup,
} from "./audit-group-process-warning-popup";
import AuditGroupProcessManagerWarningPopup, {
  toggleAuditGroupProcessManagerWarningPopup,
} from "./audit-group-process-manager-warning-popup";
import { convertDateFormat, transformDate } from "../../utils/dateUtils";
import { GET_USER_TASK_LIST_BY_LEVEL } from "../../common_components/user-task-list/services/get-user-task-list-by-level";
import { bindActionCreators } from "redux";
import { actions as asyncActions } from "async-ops";
import { showNotifyPopup } from "../../common_components/common-functions";
import { CASE_ADD_LOCATIONS } from "../../common_components/add-case-manual/constant";
import { SET_CASE_FORM_DATA } from "./case-detail/case-data/reducers/case-data-reducer";

export const getAuditPeriodByDate = (auditPeriods, date: Date) => {
  const dateString = transformDate(date);
  let returnAuditPeriod = null;
  for (var x = 0; x < auditPeriods.length; x++) {
    if (new Date(auditPeriods[x].beginDateString) <= new Date(dateString)) {
      returnAuditPeriod = auditPeriods[x];
    }
  }
  return returnAuditPeriod;
};
const AuditPropertiesGeneralSectionComponent: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
        asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
);
  const selectedAuditId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData?.eaAuditId,
    isEqual
  );
  const isAuditSafeToSave = useSelector((state) => {
    const auditStatus = state["auditPropertiesReducer"].auditStatus?.find(
      (x) =>
        x?.statusId ===
        state["auditPropertiesReducer"].auditPropertiesData.statusId
    );
    return (
      props.remainingRequiredFieldsCount === 0 ||
      (auditStatus && auditStatus.statusType.toUpperCase() !== COMPLETED_SATUS)
    );
  });

  useEffect(() => {
    dispatch({
      type: SET_IS_COMPONENT_LOADED_FLAG,
      data: {
        isAuditPropertiesGeneralSectionLoaded: true,
      },
    });
    return () => {
      dispatch({
        type: SET_IS_COMPONENT_LOADED_FLAG,
        data: {
          isAuditPropertiesGeneralSectionLoaded: false,
        },
      });
    };
  }, []);
  useEffect(() => {
    if(selectedAuditId){
      asyncAction.asyncOperationStart(GET_USER_TASK_LIST_BY_LEVEL, {
        attachedLevelId: selectedAuditId,
        attachedLevelName: 'EA',
        includeNonAttachedLevelTasks: false,
      });
    }
  }, [selectedAuditId]);
  const auditPropertiesValidationGroup = "auditPropertiesValidationGroup";
  const validateReferenceId = (e) => {
    return isAuditSafeToSave || (props.selectedProcessTemplateRequiredFields &&
      props.selectedProcessTemplateRequiredFields.filter(
        (x) => x.eaRequiredFieldName?.toLowerCase() === REFERENCE_ID
      ).length > 0 &&
      !e.value
      ? false
      : true);
  };
  const validateNotificationDate = (e) => {
    return isAuditSafeToSave || (props.selectedProcessTemplateRequiredFields &&
      props.selectedProcessTemplateRequiredFields.filter(
        (x) => x.eaRequiredFieldName?.toLowerCase() === NOTIFICATION_DATE
      ).length > 0 &&
      !e.value
      ? false
      : true);
  };
  const validateAuditPeriod = (e) => {
    return isAuditSafeToSave || (props.selectedProcessTemplateRequiredFields &&
      props.selectedProcessTemplateRequiredFields.filter(
        (x) => x.eaRequiredFieldName?.toLowerCase() === AUDIT_PERIOD
      ).length > 0 &&
      !e.value
      ? false
      : true);
  };
  const referenceId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData.referenceId,
    isEqual
  );

  const sendRequest = function(value) {
    return new Promise((resolve) => {
      setTimeout(function() {
        resolve(value);
      }, 1000);
    });
  };

  const asyncValidation = async function(params) {
    let auditId = selectedAuditId ? selectedAuditId : 0;
    if (params.value != referenceId) {
      var response = await callOperation(GET_REFERENCE_ID_EXIST, {
        referenceId: params.value,
        auditId: auditId,
      }).then((response) => {
        return sendRequest(response.isReferenceIdExist);
      });
      return response ? false : true;
    }
  };


  const prevNotificationDate = useSelector(
    (state) => state["auditPropertiesReducer"].prevNotificationDate,
    isEqual
  );

  const userTaskList = useSelector(
    (state) => state["userTaskListReducer"].userTaskList,
    isEqual
  );

  const oldAuditPropertiesObject = useSelector(
    (state) => state["auditPropertiesReducer"].oldAuditPropertiesObject,
    isEqual
  );

  const processesTemplatesList = useSelector(
    (state) => state["auditPropertiesReducer"].processesTemplatesList,
    isEqual
  );

  const eaProcessTemplateId = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData.eaProcessTemplateId,
    isEqual
  );

  const processManagerId = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData.processManagerId,
    isEqual
  );

  const processTemplateRoundList = useSelector(
    (state) => state["externalAuditReducer"].processTemplateRoundList,
    isEqual
  );

  const isNotificationDateWarningPopupVisible = useSelector(
    (state) =>
      state["auditPropertiesReducer"].isNotificationDateWarningPopupVisible,
    isEqual
  );

  const isStatusChangeWarningPopupVisible = useSelector(
    (state) =>
      state["auditPropertiesReducer"].isStatusChangeWarningPopupVisible,
    isEqual
  );

  const isAuditGroupProcessWarningPopupVisible = useSelector(
    (state) =>
      state["auditPropertiesReducer"].isAuditGroupProcessWarningPopupVisible,
    isEqual
  );

  const isAuditGroupProcessManagerWarningPopupVisible = useSelector(
    (state) =>
      state["auditPropertiesReducer"]
        .isAuditGroupProcessManagerWarningPopupVisible,
    isEqual
  );
  const isProcessTemplateValid = useSelector(
    (state) => state["externalAuditReducer"].isProcessTemplateValid,
    isEqual
  );
  const processTemplateDataSource = useSelector(
    (state) => state["auditPropertiesReducer"].processTemplateDataSource,
    isEqual
  );

  const termedProcessTemplate = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData.termedProcessTemplate,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  ); 
  const allAuditStatusList = useSelector(
    (state) => state["auditPropertiesReducer"].allAuditStatusList
  );

  const onChangeStatusWarningOkClick = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          statusId: oldAuditPropertiesObject.statusId,
        },
      },
    });
    dispatch({
      type: SET_EXTERNAL_AUDIT_SELECTED_INDEX,
      data: {
        externalAuditSelectedIndex: 2,
      },
    });
    dispatch({
      type: SET_USER_TASK_GRID_FILTER,
      data: {
        isUserTaskListGridSetFiltered: true,
      },
    });
  };

  const onCancelNotificationDateWarning = (e) => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          notificationDate: prevNotificationDate,
        },
      },
    });
  };

  const onAuditGroupProcessWarningCancelClick = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          auditGroupId: oldAuditPropertiesObject.auditGroupId,
        },
      },
    });
  };

  const onAuditGroupProcessWarningOkClick = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          eaProcessTemplateId: null,
          oldEaProcessTemplateId: oldAuditPropertiesObject.eaProcessTemplateId,
          hasProcessChangedBasedOnAuditGroup: true,
        },
      },
    });
  };

  const onAuditGroupProcessManagerWarningCancelClick = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          auditGroupId: oldAuditPropertiesObject.auditGroupId,
        },
      },
    });
  };

  const onAuditGroupProcessManagerWarningOkClick = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          processManagerId: null,
        },
      },
    });
  };

  const hideConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  };
  const showProcessChangeConfirmationPopup = (message) => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        onConfirm: () => {
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data: {
              auditPropertiesData: {
                hasProcessTemplateChanged: true,
              },
            },
          });
          hideConfirmationPopup();
        },
        title: "Warning",
        visible: true,
        confirmShown: true,
        declineShown: true,
        width: 380,
        height: 200,
        contentHtml: message,
        onDecline: () => {
          onCancelProcessChange();
          hideConfirmationPopup();
        },
      },
    });
  };
  const toggleProcessChangeConfirmationPopupVisible = (isVisible, message) => {
    if (isVisible) {
      showProcessChangeConfirmationPopup(message);
    } else {
      hideConfirmationPopup();
    }
  };

  const onCancelProcessChange = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          eaProcessTemplateId: oldAuditPropertiesObject.eaProcessTemplateId,
        },
      },
    });
  };

  const finalProcessTemplateList = useMemo(() => {
    if (processTemplateDataSource?.length > 0) {
      var validProcessTemplateList = cloneDeep(processTemplateDataSource);
      if (
        eaProcessTemplateId > 0 &&
        termedProcessTemplate?.eaProcessTemplateId > 0
      ) {
        validProcessTemplateList.push(termedProcessTemplate);
        return validProcessTemplateList;
      } else {
        return validProcessTemplateList;
      }
    } else {
      return [];
    }
  }, [
    processTemplateDataSource?.length,
    eaProcessTemplateId,
    termedProcessTemplate,
  ]);

  const [statusOptions, setStatusOptions] = useState(props.auditStatus);

  useEffect(() => {
    if (allAuditStatusList?.length > 0) {
      const isValueInList = props.auditStatus.some(
        (option) => option.statusId === auditPropertiesData.statusId
      );
      if (!isValueInList && auditPropertiesData.statusId) {
        const missingItem = allAuditStatusList?.filter(
          (x) => x.statusId === auditPropertiesData.statusId
        );
        const updatedDataSource = [...props.auditStatus, missingItem?.[0]];
        setStatusOptions(updatedDataSource);
      } else {
        setStatusOptions(props.auditStatus);
      }
    }
  }, [props.auditStatus, auditPropertiesData.statusId, allAuditStatusList?.length]);  


  return (
    <div>
      <div className="subsection-title application-section-primary-background-color ">
        General
      </div>
      <div className="section-padding">
        <div
          className={
            props?.isExternalAuditReadOnly ? "mdae-readonly-content" : ""
          }
        >
          <div>
            <MdaeTextBox
              required
              tabIndex={1}
              id={"txtAuditTitle"}
              mdaeTextBoxTitle={"Title"}
              maxLength={256}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_AUDIT_PROPERTIES_DATA,
                  reducerName: "auditPropertiesReducer",
                  widgetOptionBindings: {
                    value: "auditPropertiesData.title",
                  },
                },
              ]}
            >
              <Validator validationGroup={auditPropertiesValidationGroup}>
                <RequiredRule message="Title is required" />
              </Validator>
            </MdaeTextBox>
          </div>
          <div
            className={
              isProcessTemplateValid
                ? "widget-separation-margin-top"
                : "widget-separation-margin-top invalid-content-type-in-process-template"
            }
          >
            <ProcessTemplateComponent
              auditMode={props.mode}
              finalProcessTemplateList={finalProcessTemplateList}
              isProcessTemplateValid={isProcessTemplateValid}
              isReadOnly={props.mode == auditModes.EDIT}
            />
          </div>
          <div className={"widget-separation-margin-top"}>
            <AuditGroupComponent
              mode={props.mode}
              setProcessManagerToCurrentUser={
                props.setProcessManagerToCurrentUser
              }
              validateAuditGroup={auditPropertiesValidationGroup}
              isReadOnly={false}
            />
          </div>
          <div className={"widget-separation-margin-top"}>
            <ProcessMannagerComponent
              validationGroup={auditPropertiesValidationGroup}
              readOnly={false}
            />
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeTextBox
              id={"txtReferenceID"}
              tabIndex={5}
              required={
                props.selectedProcessTemplateRequiredFields &&
                props.selectedProcessTemplateRequiredFields.filter(
                  (x) => x.eaRequiredFieldName?.toLowerCase() === REFERENCE_ID
                ).length > 0
                  ? true
                  : false
              }
              mdaeTextBoxTitle={"Reference ID"}
              maxLength={100}
              onValueChange={(e) => {}}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_AUDIT_PROPERTIES_DATA,
                  reducerName: "auditPropertiesReducer",
                  widgetOptionBindings: {
                    value: "auditPropertiesData.referenceId",
                  },
                },
              ]}
            >
              <Validator validationGroup={auditPropertiesValidationGroup}>
                <CustomRule
                  message={"Reference ID is required"}
                  validationCallback={validateReferenceId}
                />
                <AsyncRule
                  type="async"
                  message={"Reference Id already exist"}
                  ignoreEmptyValue={true}
                  validationCallback={asyncValidation}
                />
              </Validator>
            </MdaeTextBox>
          </div>
          <div className={"widget-separation-margin-top field-width"}>
            <MdaeDateBox
              id="dtNotificationDate"
              tabIndex={6}
              required={
                props.selectedProcessTemplateRequiredFields &&
                props.selectedProcessTemplateRequiredFields.filter(
                  (x) =>
                    x.eaRequiredFieldName?.toLowerCase() === NOTIFICATION_DATE
                ).length > 0
                  ? true
                  : false
              }
              value={auditPropertiesData.notificationDate}
              onValueChanged={(e) => {
                dispatch({
                  type: SET_AUDIT_PROPERTIES_DATA,
                  data: {
                    auditPropertiesData: {
                      notificationDate: e.value,
                    },
                  },
                });
              }}
              mdaeDateBoxTitle="Notification Date"
            >
              <Validator validationGroup={auditPropertiesValidationGroup}>
                <CustomRule
                  message="Notification Date is required"
                  validationCallback={validateNotificationDate}
                />
              </Validator>
            </MdaeDateBox>
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              required
              id={"ddlStatus"}
              tabIndex={7}
              mdaeDropDownBoxTitle={"Status"}
              displayExpr={"displayAlias"}
              valueExpr={"statusId"}
              dataSource={statusOptions}
              onValueChanged={(e) => {
                if (props.mode === auditModes.EDIT && e.event) {
                  let filteredStatus = statusOptions?.filter(
                    (x) => x?.statusId == e.value
                  );
                  let inCompleteTaskList = userTaskList?.filter(
                    (x) =>
                      x.status.toUpperCase() !== COMPLETED_SATUS &&
                      x.requiredForAuditCompletionInd
                  );
                  if (
                    filteredStatus[0]?.statusCd.toUpperCase() ===
                      COMPLETED_SATUS &&
                    filteredStatus[0]?.curated == "Y" &&
                    inCompleteTaskList?.length > 0
                  ) {
                    toggleStatusChangeeWarningPopup(true, dispatch);
                  }
                  if (
                    filteredStatus[0]?.statusType.toUpperCase() ===
                      COMPLETED_SATUS &&
                    props.remainingRequiredFieldsCount > 0
                  ) {
                    showNotifyPopup(dispatch, "You must complete all required fields before changing the status to Completed.");
                  }
                }
              }}
              onValueChange={(e) => {
                if (props.mode === auditModes.EDIT) {
                  let filteredStatus = statusOptions?.filter(
                    (x) => x?.statusId == e
                  );
                  let inCompleteTaskList = userTaskList?.filter(
                    (x) =>
                      x.status.toUpperCase() !== COMPLETED_SATUS &&
                      x.requiredForAuditCompletionInd
                  );
                  if (
                    filteredStatus[0]?.statusCd.toUpperCase() ===
                      COMPLETED_SATUS &&
                    filteredStatus[0]?.curated == "Y" &&
                    inCompleteTaskList?.length == 0
                  ) {
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: {
                          completionDate: convertDateFormat(new Date()),
                        },
                      },
                    });
                  }
                }
              }}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_AUDIT_PROPERTIES_DATA,
                  reducerName: "auditPropertiesReducer",
                  widgetOptionBindings: {
                    value: "auditPropertiesData.statusId",
                  },
                },
              ]}
            >
              <Validator validationGroup={auditPropertiesValidationGroup}>
                <RequiredRule message="Status is required" />
              </Validator>
            </MdaeSelectBox>
          </div>
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlAuditPeriod"}
              tabIndex={8}
              required={
                props.selectedProcessTemplateRequiredFields &&
                props.selectedProcessTemplateRequiredFields.filter(
                  (x) => x.eaRequiredFieldName?.toLowerCase() === AUDIT_PERIOD
                ).length > 0
                  ? true
                  : false
              }
              onValueChanged={(e) => {
                dispatch({
                  type: SET_AUDIT_PROPERTIES_DATA,
                  data: {
                    auditPropertiesData: {
                      auditPeriodId: e.value,
                    },
                  },
                });
              }}
              mdaeDropDownBoxTitle={"Audit Period"}
              displayExpr={"auditPeriodName"}
              valueExpr={"auditPeriodId"}
              dataSource={props.auditPeriod}
              value={auditPropertiesData.auditPeriodId}
            >
              <Validator validationGroup={auditPropertiesValidationGroup}>
                <CustomRule
                  message="Audit Period is required"
                  validationCallback={validateAuditPeriod}
                />
              </Validator>
            </MdaeSelectBox>
          </div>
          <div className={"widget-separation-margin-top field-width"}>
            <StartDateComponent
              mode={props.mode}
              validationGroup={auditPropertiesValidationGroup}
              isReadOnly={false}
            />
          </div>
          {props.mode == auditModes.EDIT && (
            <div className={"widget-separation-margin-top field-width"}>
              <MdaeDateBox
                id="dtCompletionDate"
                tabIndex={10}
                mdaeDateBoxTitle="Completion Date"
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_AUDIT_PROPERTIES_DATA,
                    reducerName: "auditPropertiesReducer",
                    widgetOptionBindings: {
                      value: "auditPropertiesData.completionDate",
                    },
                  },
                ]}
              ></MdaeDateBox>
            </div>
          )}
          {isNotificationDateWarningPopupVisible && (
            <NotificationDateWarningPopup
              toggleNotificationDateWarningPopup={
                props.toggleNotificationDateWarningPopup
              }
              onCancelNotificationDateWarning={onCancelNotificationDateWarning}
            />
          )}
          {isStatusChangeWarningPopupVisible && (
            <StatusChangeWarningPopup
              toggleStatusChangeeWarningPopup={toggleStatusChangeeWarningPopup}
              onChangeStatusWarningOkClick={onChangeStatusWarningOkClick}
            />
          )}
          {isAuditGroupProcessWarningPopupVisible && (
            <AuditGroupProcessWarningPopup
              toggleAuditGroupProcessWarningPopup={
                toggleAuditGroupProcessWarningPopup
              }
              onAuditGroupProcessWarningCancelClick={
                onAuditGroupProcessWarningCancelClick
              }
              onAuditGroupProcessWarningOkClick={
                onAuditGroupProcessWarningOkClick
              }
            />
          )}
          {isAuditGroupProcessManagerWarningPopupVisible && (
            <AuditGroupProcessManagerWarningPopup
              toggleAuditGroupProcessManagerWarningPopup={
                toggleAuditGroupProcessManagerWarningPopup
              }
              onAuditGroupProcessManagerWarningCancelClick={
                onAuditGroupProcessManagerWarningCancelClick
              }
              onAuditGroupProcessManagerWarningOkClick={
                onAuditGroupProcessManagerWarningOkClick
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};
interface IProcessTemplateComponentProps{
  isReadOnly: boolean;
  isProcessTemplateValid: boolean;
  auditMode: string;
  finalProcessTemplateList?: any[];
  tabIndex?: number;
  isSyncAuditAndCases?:boolean
}
export const ProcessTemplateComponent: FC<IProcessTemplateComponentProps> = (props) => {
  const dispatch = useDispatch();
  const processTemplateDataSource = useSelector(
    (state) => state["auditPropertiesReducer"].processTemplateDataSource,
    isEqual
  );
  return (
    <MdaeSelectBox
      id={"ddlProcess"}
      tabIndex={props.tabIndex || 2}
      readOnly={props.isReadOnly}
      mdaeDropDownBoxTitle={"Process"}
      displayExpr={"name"}
      valueExpr={"eaProcessTemplateId"}
      isValid={props.isProcessTemplateValid}
      elementAttr={{
        title: props.isProcessTemplateValid
          ? ""
          : "This Process contains a Content Type that is no longer valid for the Review Contractor associated with this Requester. Please update your Content Type selection",
      }}
      onValueChanged={(e) =>
        dispatch(
          onProcessTemplateValueChanged(
            e,
            props.auditMode,
            toggleAuditGroupProcessManagerWarningPopup,
            props.isSyncAuditAndCases,
          )
        )
      }
      itemRender={(e) => {
        if (e.activeInd !== false) {
          return <div>{e.name}</div>;
        }
      }}
      dataSource={props.finalProcessTemplateList ?? (processTemplateDataSource || [])}
      mdaeDataUpdaterConfig={[
        {
          actionType: SET_AUDIT_PROPERTIES_DATA,
          reducerName: "auditPropertiesReducer",
          widgetOptionBindings: {
            value: "auditPropertiesData.eaProcessTemplateId",
          },
        },
      ]}
    ></MdaeSelectBox>
  );
};
interface IAuditGroupComponent{
  mode: string;
  setProcessManagerToCurrentUser: (processManagerId: number) => void;
  validateAuditGroup: string;
  isReadOnly: boolean;
  page?:string;
  claimTypeCd?:string;
}
export const AuditGroupComponent: FC<IAuditGroupComponent> = (
  props
) => {
  const dispatch = useDispatch();
    const filteredAuditGroups = useSelector(
    (state) => state["auditPropertiesReducer"].filteredAuditGroups,
    isEqual
  );
  const allProcessManagersList = useSelector(
    (state) => state["auditPropertiesReducer"].allProcessManagersList,
    isEqual
  );
  return (
    <MdaeSelectBox
      id={"ddlAuditGroup"}
      tabIndex={3}
      mdaeDropDownBoxTitle={"Audit Group"}
      displayExpr={"name"}
      valueExpr={"auditGroupId"}
      dataSource={props.page===CASE_ADD_LOCATIONS.CASE_SEARCH_PAGE ? getAuditGroupsForClaim(props.claimTypeCd,filteredAuditGroups):filteredAuditGroups || []}
      readOnly={props.isReadOnly}
      required={!props.isReadOnly}
      onValueChanged={(e) =>
        dispatch(
          onAuditGroupValueChanged(
            e,
            props.mode,
            allProcessManagersList,
            props.setProcessManagerToCurrentUser,
          )
        )
      }
      mdaeDataUpdaterConfig={[
        {
          actionType: SET_AUDIT_PROPERTIES_DATA,
          reducerName: "auditPropertiesReducer",
          widgetOptionBindings: {
            value: "auditPropertiesData.auditGroupId",
          },
        },
      ]}
    >
      <Validator validationGroup={props.validateAuditGroup}>
        {!props.isReadOnly && <RequiredRule message="Audit Group is required" />}
      </Validator>
    </MdaeSelectBox>
  );
};
interface IStartDateComponentProps {
  validationGroup: string;
  mode: string;
  isReadOnly: boolean;
  title?: string;
}
export const StartDateComponent: FC<IStartDateComponentProps> = (props) => {
  const dispatch = useDispatch();
   const auditPeriodList = useSelector(
      (state) => state["auditPropertiesReducer"].auditPeriod
    );
    const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData
  ); 
  const handleStartDateChange = useCallback((e) => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          hasStartDateChanged: true,
        },
      },
    });
  }, []);

  const updateAuditPeriod = useCallback(
    (startDate) => {
      const auditPeriod = getAuditPeriodByDate(
        auditPeriodList,
        new Date(startDate)
      );
      if (auditPeriod) {
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              auditPeriodId: auditPeriod.auditPeriodId,
            },
          },
        });
      }
    },
    [auditPeriodList, dispatch]
  );

useEffect(() => {
  if (
    auditPropertiesData.startDate &&
    auditPeriodList?.length > 0 &&
    (auditPropertiesData.auditPeriodId == null ||
      auditPropertiesData.auditPeriodId === 0)
  ) {
    updateAuditPeriod(auditPropertiesData.startDate);
  }
}, [
  auditPropertiesData.startDate,
  auditPeriodList,
  auditPropertiesData.auditPeriodId,
]);

  return (
    <MdaeDateBox
      readOnly={props.isReadOnly}
      required={!props.isReadOnly}
      id="dtStartDate"
      tabIndex={9}
      mdaeDateBoxTitle={props.title ? props.title : "Start Date"}
      value={auditPropertiesData.startDate}
      onValueChanged={(e) => {
        if (props.mode === auditModes.EDIT) handleStartDateChange(e);
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              startDate: e.value,
            },
          },
        });
        if (e.event || props.mode === auditModes.CREATE) {
          updateAuditPeriod(e.value);
        }
      }}
    >
      <Validator validationGroup={props.validationGroup}>
        {!props.isReadOnly && (
          <RequiredRule message="Please enter an start date." />
        )}
      </Validator>
    </MdaeDateBox>
  );
};
interface IProcessMannagerComponentProps {
  validationGroup: string;
  readOnly?: boolean;
}
export const ProcessMannagerComponent: FC<IProcessMannagerComponentProps> = (
  props
) => {
  const dispatch = useDispatch();
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const processManagers = useSelector(
    (state) => state["auditPropertiesReducer"].processManagers,
    isEqual
  );
  return (
    <MdaeSelectBox
      required
      id={"Manager"}
      tabIndex={4}
      mdaeDropDownBoxTitle={"Audit Process Manager"}
      displayExpr={"fullName"}
      valueExpr={"auditUserId"}
      value={auditPropertiesData.processManagerId}
      dataSource={processManagers}
      readOnly={props.readOnly}
      onValueChanged={(e) => {
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              processManagerId: e.value,
            },
          },
        });
      }}
    >
      <Validator validationGroup={props.validationGroup}>
        {!props.readOnly && <RequiredRule message="Audit Process Manager is required" />}
      </Validator>
    </MdaeSelectBox>
  );
};

interface ICaseProcessManagerComponentProps {
  validationGroup: string;
  readOnly?: boolean;
}
export const CaseProcessManagerComponent: FC<ICaseProcessManagerComponentProps> = (
  props
) => {
  const dispatch = useDispatch();
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const processManagers = useSelector(
    (state) => state["auditPropertiesReducer"].processManagers,
    isEqual
  );
  return (
    <MdaeSelectBox
      required
      id={"caseProcessManager"}
      tabIndex={4}
      mdaeDropDownBoxTitle={"Case Process Manager"}
      displayExpr={"fullName"}
      valueExpr={"auditUserId"}
      value={caseData.caseProcessManagerId?caseData.caseProcessManagerId:caseData.processManagerId}
      dataSource={processManagers}
      onValueChanged={(e) => {
        dispatch({
          type: SET_CASE_FORM_DATA,
          data: {
            caseData: {
              caseProcessManagerId: e.value,
            },
          },
        });
      }}
    >
      <Validator validationGroup={props.validationGroup}>
        {!props.readOnly && (
          <RequiredRule message="Case Process Manager is required" />
        )}
      </Validator>
    </MdaeSelectBox>
  );
};

export default AuditPropertiesGeneralSectionComponent;
